import FormCheckboxComponent from './FormCheckboxComponent';

export default FormCheckboxComponent;
